import { FolderContext } from "@common/dto/folder/context";

export const MODULE_NAME = 'FHQ_DESIGN_TOOL';

export const FIRST_NAME_ALWAYS_HAS_INDIVIDUAL_CONTEXT = FolderContext.individual;